const COST_BY_INITIATIVE_SCHEMA = {
  i: 'initiative_id',
  n: 'name',
  ctd: 'cost_to_date',
  d: 'date',
  c: 'cost',
  tm: 'team_name',
  tid: 'team_id',
} as const;

type FlatInitiative = {
  i: string;
  n: string;
  ctd: number;
};

type FlatInitiativeTimeSeries = {
  i: string;
  d: string;
  c: number;
};

type FlatInitiativeTeamData = {
  i: string;
  tid: string;
  tm: string;
  d: string;
  c: number;
};

type FlattenedCostByInitiativeData = {
  schema: typeof COST_BY_INITIATIVE_SCHEMA;
  initiatives: FlatInitiative[];
  timeSeries: FlatInitiativeTimeSeries[];
  teamData: FlatInitiativeTeamData[];
};

export { COST_BY_INITIATIVE_SCHEMA };
export type { FlatInitiative, FlatInitiativeTeamData, FlatInitiativeTimeSeries, FlattenedCostByInitiativeData };
